import React from "react";
import Loader from "../Loader/Loader";

const Button = ({
  type,
  text,
  customClass,
  disabled,
  onClick,
  submit,
  isLoading,
}) => {
  return (
    <>
      <button
        type={type}
        submit={submit}
        disabled={disabled}
        onClick={onClick}
        className={`w-fit relative text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center hover:shadow-md ${customClass} ${
          !disabled
            ? "bg-[--primary] cursor-pointer"
            : "bg-[--primary] opacity-60 cursor-not-allowed"
        } `}
      >
        {isLoading && (
          <div className="absolute inset-0 flex justify-center items-center">
            <Loader />
          </div>
        )}
        {text}
      </button>
    </>
  );
};

export default Button;
